/**
 * Os dois modos do jogo, e onde cada um existe.
 *
 * **1 Jogador** roda inteiro no aparelho, sem servidor: é o modo do arquivo
 * exportado, o único lugar onde o hotseat de até oito treinadores faz sentido,
 * e o único que funciona sem sinal.
 *
 * **Online Multiplayer** é a carreira da conta, que vive no servidor, mais as
 * ligas e o ranqueado.
 *
 * A diferença entre as plataformas não é gosto, é o que cada uma consegue
 * prometer. O aplicativo empacotado tem o motor instalado junto e uma pasta
 * própria para guardar arquivo, então ele oferece os dois. O navegador não tem
 * nem uma coisa nem outra de forma confiável: a aba pode ser fechada, o
 * armazenamento pode ser limpo pelo próprio navegador e não há arquivo para
 * onde exportar. Por isso, no navegador, o jogo é só online.
 */

import { detectarPlataforma } from "./saves/escolha";

export type Modo = "umJogador" | "online";

/** Estamos dentro do aplicativo instalado (Windows ou Android)? */
export function ehAplicativo(): boolean {
  return detectarPlataforma() !== "web";
}

/**
 * Os modos que esta plataforma oferece, na ordem em que a tela mostra.
 *
 * No aplicativo, 1 Jogador vem primeiro: quem abriu o aplicativo instalado
 * costuma estar querendo jogar sozinho, e quem quer liga com gente sabe que
 * precisa entrar na conta.
 */
export function modosDaPlataforma(): Modo[] {
  return ehAplicativo() ? ["umJogador", "online"] : ["online"];
}

/**
 * O modo com que o jogo abre.
 *
 * `null` no aplicativo quer dizer "ainda não escolheu", e a tela inicial
 * pergunta. No navegador não há o que perguntar.
 */
export function modoInicial(): Modo | null {
  return ehAplicativo() ? null : "online";
}
